module.exports = __webpack_public_path__ + "img/Game_target_Z-07.6805389b.png";